import { HttpRequest } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Subject } from "rxjs";
import { AppEvents } from "../app-events";

@Injectable({
  providedIn: "root",
})
export class SpinnerService {
  private loaderCount = 0;
  private showLoading = new Subject<boolean>();
  private ignoredRequestUrlMatchers: RegExp[] = [];
  private ignoredRequestUrlPrefixes = [];

  showLoading$ = this.showLoading.asObservable();

  constructor() {}

  init() {
    AppEvents.beforeRequest.subscribe((request: HttpRequest<any>): void => {
      if (this.shouldIgnore(request)) {
        return;
      }
      this.incrementLoading();
    });
    AppEvents.afterRequest.subscribe((request: HttpRequest<any>): void => {
      if (this.shouldIgnore(request)) {
        return;
      }
      this.decrementLoading();
    });
  }

  registerIgnoredRequestUrlMatcher(exp: RegExp) {
    this.ignoredRequestUrlMatchers.push(exp);
  }

  decrementLoading() {
    if (this.loaderCount === 0) {
      return;
    }
    this.loaderCount--;
    this.showLoading.next(this.loaderCount !== 0);
  }

  reset() {
    this.loaderCount = 0;
    this.showLoading.next(false);
  }

  incrementLoading() {
    this.loaderCount++;
    this.showLoading.next(this.loaderCount !== 0);
  }

  private shouldIgnore(request: HttpRequest<any>) {
    // TODO find a better way to disable spinners on a per-request basis.
    const noSpinnerHeader = request.headers.get("no-spinner");
    if (
      !!this.ignoredRequestUrlMatchers.find((p) => p.test(request.url)) ||
      (typeof noSpinnerHeader !== "undefined" && noSpinnerHeader !== null)
    ) {
      return true;
    }
    return false;
  }

  registerIgnoredRequestUrlPrefix(urlPrefix: string) {
    this.ignoredRequestUrlPrefixes.push(urlPrefix);
  }
}
